import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGhost } from '@fortawesome/pro-regular-svg-icons/faGhost'

export const NotFoundContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 4rem;
    padding-bottom: 4rem;
    height: 100%;

    p {
        font-size: 1.1rem;
    }
`

const NotFoundMessage = ({
    url = '/',
    message = "The page you're looking for could not be found.",
    buttonLabel = 'Go to Dashboard',
}) => (
    <NotFoundContainer data-testid="not-found-message">
        <FontAwesomeIcon icon={faGhost} size="6x" className="!mb-4" />
        <p>{message}</p>

        <Link to={url} className="btn btn-primary">
            {buttonLabel}
        </Link>
    </NotFoundContainer>
)

export default NotFoundMessage
